// Indicateur de qualité d'une donnée (C3, D-012, D-022) porté par chaque déclaration et chaque agrégat :
// - perimee   : dernière donnée au-delà du seuil de péremption ;
// - en_attente: déclaration retenue en attente de validation (anomalie de contrôle ou circuit systématique) ;
// - connectee : donnée reçue d'un connecteur (API sécurisée, niveau 3) ;
// - verifiee  : donnée vérifiée ou validée par une personne habilitée, ou constatée par inspection ;
// - estimee   : valeur calculée (par exemple consommation par variation de stock) ;
// - declaree  : donnée déclarée et cohérente, acceptée automatiquement (D-012).

import { evaluerFraicheur, type SeuilsFraicheur } from '../regles/fraicheur';
import { SEUILS_FRAICHEUR_DEFAUT } from '../constantes';

export const QUALITES_DONNEE = ['connectee', 'declaree', 'verifiee', 'estimee', 'en_attente', 'perimee'] as const;
export type QualiteDonnee = (typeof QUALITES_DONNEE)[number];

export const LIBELLES_QUALITE: Record<QualiteDonnee, string> = {
  connectee: 'Connectée',
  declaree: 'Déclarée',
  verifiee: 'Vérifiée',
  estimee: 'Estimée',
  en_attente: 'En attente de validation',
  perimee: 'Périmée',
};

export interface EntreeQualite {
  source: string;
  etatValidation: string;
  horodatage: string | Date | null;
  estimee?: boolean;
  maintenant?: Date;
  seuils?: SeuilsFraicheur;
}

export function calculerQualite(e: EntreeQualite): QualiteDonnee {
  const fraicheur = evaluerFraicheur(e.horodatage, e.maintenant ?? new Date(), e.seuils ?? SEUILS_FRAICHEUR_DEFAUT);
  if (fraicheur === 'perimee') return 'perimee';
  if (e.etatValidation === 'en_attente_validation' || e.etatValidation === 'conteste') return 'en_attente';
  if (e.estimee) return 'estimee';
  if (e.etatValidation === 'verifie' || e.etatValidation === 'valide') return 'verifiee';
  if (e.source === 'api') return 'connectee';
  return 'declaree';
}

/** Qualité la plus faible d'un ensemble (pour un agrégat) : l'agrégat porte la qualité de sa source la moins sûre. */
export function qualiteAgregee(qualites: readonly QualiteDonnee[]): QualiteDonnee | null {
  const ordre: QualiteDonnee[] = ['perimee', 'en_attente', 'estimee', 'declaree', 'connectee', 'verifiee'];
  for (const q of ordre) if (qualites.includes(q)) return q;
  return null;
}
